import { Component, Inject } from '@angular/core';
import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { BaseComponent } from '@app/shared/components/base/base.component';
import { InsignDistributionJob } from '@app/shared/models/distribution-doc-models';
import { UntypedFormControl, Validators } from '@angular/forms';

@Component({
    templateUrl: './insign-sms-distribution-dialog.component.html',
    styleUrls: ['./insign-sms-distribution-dialog.component.scss']
})
export class InSignSMSDistributionDialogComponent extends BaseComponent {

    public insign_sms_to: UntypedFormControl;
    public insign_sms_body: UntypedFormControl;

    get saveBtnEnabled() {
        return this.insign_sms_to.valid && this.insign_sms_body.valid;
    }

    get isCaseDistributionJob(): boolean {
        return !!this.data && !this.data.workflow_id;
    }

    constructor(public dialogRef: MatDialogRef<InSignSMSDistributionDialogComponent>,
                @Inject(MAT_DIALOG_DATA) public data: InsignDistributionJob) {
        super();
        this._idPrefix = 'insign-sms-distribution-dialog.';

        this.insign_sms_to = new UntypedFormControl(
            {
                value: this.data.insign_sms_to,
                disabled: this.disabled
            },
            {
                updateOn: 'blur',
                validators: this.isCaseDistributionJob ? [Validators.required] : []
            });

        this.insign_sms_body = new UntypedFormControl(
            {
                value: this.data.insign_sms_body,
                disabled: this.disabled
            },
            {
                updateOn: 'blur',
                validators: this.isCaseDistributionJob ? [Validators.required] : []
            });
    }

    public accept(): void {
        if (this.saveBtnEnabled) {
            this.data.insign_sms_to = this.insign_sms_to.value;
            this.data.insign_sms_body = this.insign_sms_body.value;
            this.dialogRef.close(this.data);
        }
    }

    public close(): void {
        this.dialogRef.close();
    }
}
